import { motion } from "framer-motion";
import { useLang } from "@/i18n/LanguageContext";

const reveal = {
  initial: { opacity: 0, y: 36 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-70px" },
  transition: { duration: 1, ease: [0.22, 1, 0.36, 1] },
};

export const Arc = () => {
  const { t } = useLang();
  const phases = t.arc.phases;

  return (
    <section className="arc" id="arc" data-testid="arc-section">
      <div className="container">
        <motion.div className="arc__head" {...reveal}>
          <p className="label">{t.arc.label}</p>
          <h2 className="display">
            {t.arc.titleA} <em>{t.arc.titleB}</em>
          </h2>
          <p className="arc__intro">{t.arc.intro}</p>
        </motion.div>

        <div className="arc__timeline">
          {phases.map((p, i) => (
            <motion.article
              key={p.time}
              className={`arc__phase ${i === 4 ? "arc__phase--peak" : ""}`}
              data-testid={`arc-phase-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.8, delay: 0.09 * i, ease: [0.22, 1, 0.36, 1] }}
            >
              <span className="arc__time">{p.time}</span>
              <p className="arc__name">{p.name}</p>
              <h3 className="arc__title">{p.title}</h3>
              <p className="arc__desc">{p.desc}</p>
              <p className="arc__sound">{p.sound}</p>
            </motion.article>
          ))}
        </div>

        <motion.div className="arc__curve" {...reveal} data-testid="energy-curve">
          <p className="arc__curve-label">{t.arc.curve}</p>
          <svg viewBox="0 0 800 160" preserveAspectRatio="none" className="arc__curve-svg">
            <path
              d="M0,150 C100,150 140,148 220,138 C320,125 360,110 440,80 C520,52 560,40 640,18 C690,5 720,4 740,8 C770,14 785,60 800,150"
              fill="none"
              stroke="var(--wheat-deep)"
              strokeWidth="1.6"
              className="arc__curve-path"
            />
            <circle cx="220" cy="138" r="3.5" fill="var(--wheat-deep)" />
            <circle cx="440" cy="80" r="3.5" fill="var(--wheat-deep)" />
            <circle cx="700" cy="6" r="4.5" fill="var(--ember)" />
          </svg>
          <div className="arc__curve-marks">
            <span>09:00 · SILENCE</span>
            <span>17:30 · SUNSET SET</span>
            <span className="is-ember">23:00 · PEAK</span>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Arc;
